// extracted by mini-css-extract-plugin
module.exports = {"verticalText":"styles_verticalText__zmXOq","horizontalBarsWrapper":"styles_horizontalBarsWrapper__2xthH","barName":"styles_barName__1YjyZ","bar":"styles_bar__vo120"};